import { Component, OnInit } from '@angular/core';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { StoreService } from 'src/app/services/store.service';
import { NavigationExtras } from '@angular/router';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nearby',
  templateUrl: './nearby.page.html',
  styleUrls: ['./nearby.page.scss'],
})
export class NearbyPage implements OnInit {
 
  data : any;
  city : any= localStorage.getItem('city');
  a: any;

  constructor(private geolocation : Geolocation, private store : StoreService,private router : Router) { }

  ngOnInit() {
    this.geo();
   
  }

  ionViewDidEnter(){
    this.geo();
  }

  geo(){
    const GeoDataobj = {
     
      city:  localStorage.getItem('city'),
      
    }
    this.store.getNearbyStore(GeoDataobj).subscribe(res=>{
      console.log(res)
      this.data=res;
    })
  }

  onClick(item){
    console.log(item.storeId)
   
    this.router.navigate(['/sub-category-list/'+item.storeId+'/'+1])
  }
  home(){
    this.router.navigate(['/home'])
  }
  
}
